'use strict';
var parent = require('../../es/instance/sort');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/sort.js
// module id = 769
// module chunks = 13